import React from 'react';
import { content } from '../data/mock';
import './Results.css';

const Results = ({ language }) => {
  const t = content[language].results;

  const images = {
    apartment: {
      before: 'https://images.unsplash.com/photo-1516775448597-64ce06b9754e?w=600&q=80',
      after: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600&q=80'
    },
    construction: {
      before: 'https://images.pexels.com/photos/32116008/pexels-photo-32116008.jpeg?w=600',
      after: 'https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?w=600&q=80'
    }
  };

  return (
    <section id="results">
      <div className="container">
        <div className="section-head">
          <h2>{t.title}</h2>
          <p>{t.subtitle}</p>
        </div>

        <div className="before-after">
          {/* Apartment Comparison */}
          <div className="compare">
            <div className="compare-top">
              <strong>{t.comparisons[0].title}</strong>
            </div>
            <div className="scene">
              <div className="scene-image">
                <span className="label before">
                  {language === 'en' ? 'Before' : 'Antes'}
                </span>
                <img 
                  src={images.apartment.before} 
                  alt="Messy kitchen with cluttered countertops before professional cleaning"
                  loading="lazy"
                />
                <div className="scene-text">
                  {t.comparisons[0].before.map((item, i) => (
                    <div key={i}>• {item}</div>
                  ))}
                </div>
              </div>
              <div className="scene-image">
                <span className="label after">
                  {language === 'en' ? 'After' : 'Después'}
                </span>
                <img 
                  src={images.apartment.after} 
                  alt="Spotless modern kitchen after deep cleaning service"
                  loading="lazy"
                />
                <div className="scene-text">
                  {t.comparisons[0].after.map((item, i) => (
                    <div key={i}>• {item}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Construction Comparison */}
          <div className="compare">
            <div className="compare-top">
              <strong>{t.comparisons[1].title}</strong>
            </div>
            <div className="scene">
              <div className="scene-image">
                <span className="label before">
                  {language === 'en' ? 'Before' : 'Antes'}
                </span>
                <img 
                  src={images.construction.before} 
                  alt="Messy cluttered room with dishes and disorganization before cleaning"
                  loading="lazy"
                />
                <div className="scene-text">
                  {t.comparisons[1].before.map((item, i) => (
                    <div key={i}>• {item}</div>
                  ))}
                </div>
              </div>
              <div className="scene-image">
                <span className="label after">
                  {language === 'en' ? 'After' : 'Después'}
                </span>
                <img 
                  src={images.construction.after} 
                  alt="Clean organized bedroom with fresh bedding after professional cleaning"
                  loading="lazy"
                />
                <div className="scene-text">
                  {t.comparisons[1].after.map((item, i) => (
                    <div key={i}>• {item}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Results;
